export function isSpeechRecognitionSupported() {
  return !!(window.SpeechRecognition || window.webkitSpeechRecognition);
}

export function createSpeechRecognition() {
  const SpeechRecognitionCtor = window.SpeechRecognition || window.webkitSpeechRecognition;

  if (!SpeechRecognitionCtor) {
    return null;
  }

  const recognition = new SpeechRecognitionCtor();
  recognition.continuous = true;
  recognition.interimResults = true;
  recognition.lang = 'pt-BR';
  recognition.maxAlternatives = 1;

  return recognition;
}

export function splitTranscriptIntoSegments(text) {
  if (!text?.trim()) {
    return [];
  }

  return text
    .replace(/\r/g, '')
    .split(/\n+/)
    .flatMap((paragraph) => paragraph.split(/(?<=[.!?…])\s+/))
    .map((segment) => segment.trim())
    .filter((segment) => segment.length > 0);
}

export function stripTranscriptHtml(value) {
  if (!value) {
    return '';
  }

  const el = document.createElement('div');
  el.innerHTML = value;

  return (el.textContent || el.innerText || '').trim();
}
